<template>
  <v-dialog v-model="showDialog" max-width="750px" persistent>
    <v-card>
      <v-card-title class="editor-title">
        <h3>{{ $vuetify.t('$vuetify.AdminUsers.titleEdit', user.username) }}</h3>
      </v-card-title>
      <v-card-text>
        <v-text-field
          name="firstName"
          v-model="editUser.firstname"
          v-validate="'required'"
          :error-messages="errors.collect('firstName')"
          :label="this.$vuetify.t('$vuetify.AdminUsers.formFirstName')"
          required
        ></v-text-field>
        <v-text-field
          name="lastName"
          v-model="editUser.lastname"
          v-validate="'required'"
          :error-messages="errors.collect('lastName')"
          :label="this.$vuetify.t('$vuetify.AdminUsers.formLastName')"
          required
        ></v-text-field>
        <v-text-field
          name="username"
          v-model="editUser.username"
          v-validate
          :error-messages="errors.collect('username')"
          :label="this.$vuetify.t('$vuetify.AdminUsers.formLogin')"
        ></v-text-field>
        <v-text-field
          name="email"
          v-model="editUser.email"
          v-validate
          :error-messages="errors.collect('email')"
          :label="this.$vuetify.t('$vuetify.AdminUsers.formEmail')"
          required
        ></v-text-field>

      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="updateUser"
        >{{ $vuetify.t('$vuetify.Form.save') }}
        </v-btn>
        <v-btn @click="closeDialog(false)">
          {{ $vuetify.t('$vuetify.AdminUsers.formCancel') }}
        </v-btn>
      </v-card-actions>

      <v-snackbar v-model="showSnackbar" :bottom="true">
        {{ snackbarMsg }}
        <v-btn
          color="pink"
          flat
          @click="showSnackbar = false"
        >{{ $vuetify.t('$vuetify.Snackbar.close') }}
        </v-btn>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'

export default {
  $_veeValidate: {validator: 'new'},
  name: 'UserEditDialog',
  data: function () {
    return {
      showSnackbar: false,
      snackbarMsg: '',
      editUser: {
        editingId: null,
        firstname: '',
        lastname: '',
        username: '',
        origUsername: '',
        email: ''
      }
    }
  },

  beforeMount: function () {
    // setting user data
    this.editUser.editingId = this.user.id
    this.editUser.firstname = this.user.first_name
    this.editUser.lastname = this.user.last_name
    this.editUser.username = this.user.username
    this.editUser.origUsername = this.user.username
    this.editUser.email = this.user.email
  },

  computed: {
    showDialog: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('handleClose', value)
      }
    }
  },

  props: ['show', 'handleSuccess', 'handleCancel', 'user', 'users'],

  methods: {
    updateUser: async function () {
      let userData = {
        id: this.editUser.editingId,
        first_name: this.editUser.firstname,
        last_name: this.editUser.lastname,
        email: this.editUser.email
      }
      if (this.editUser.origUsername !== this.editUser.username) {
        // validate if username is available in backend
        const nameToUse = (await api.user.checkUsernames([this.editUser.username])).data[0]
        if (nameToUse !== this.editUser.username) {
          this.showSnackbar = true
          this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.nameNotAvailable')
          this.editUser.username = nameToUse
          console.error('username not available')
          return
        }
      }
      api.user.update(userData).then(res => {
        if (this.editUser.origUsername !== this.editUser.username) {
          api.user.updateUsername(this.editUser.editingId, this.editUser.username).then(res => {
            this.editUser.origUsername = this.editUser.username
            this.closeDialog(true)
          }).catch(err => {
            console.log(err)
            this.showSnackbar = true
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminUsers.usernameExists')
          })
        } else {
          this.closeDialog(true)
        }
      })
    },

    closeDialog: function (hasUserUpdated) {
      if (hasUserUpdated) {
        this.$emit('reloadUsers')
      }
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss">
.editor-title {
  justify-content: space-between;
}

.full-width {
  width: 100%;
}

.b100 {
  flex-basis: 100%;
}

.upload-btn {
  padding-right: 0 !important;
  padding-left: 0 !important;

  #labeluploadFile {
    width: calc(100% - 16px);
  }
}
</style>
